import { Box, Flex, Text, VStack } from "@chakra-ui/react";

const PaymentsExpiration = () => {
    localStorage.removeItem("paymentToken");

    return (
        <Box w={"100%"} h={"100%"}>
            <VStack w={"100%"} h={"100%"} justifyContent={"center"}>
                <Flex
                    w={"54px"}
                    h={"54px"}
                    borderRadius={"full"}
                    border={"3px solid #bdbdbd"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    mb={"10px"}
                >
                    <Text
                        fontSize="34px"
                        fontWeight={"semibold"}
                        color={"#bdbdbd"}
                    >
                        !
                    </Text>
                </Flex>
                <Text fontSize="22px" fontWeight={"semibold"}>
                    결제 되었거나 만료된 요청입니다
                </Text>
                <Text fontSize="14px" color={"#757575"}>
                    궁금한 점이 있으실 경우 상담을 신청해 주세요
                </Text>
            </VStack>
        </Box>
    );
};

export default PaymentsExpiration;
